import BaseStore from '../Base'
import _ from 'lodash'
import {Buffer} from 'buffer'
import {Actions} from './Constants'

import {NetworkStore} from 'api/network'
import {DeviceStore} from 'api/device'

export class MessageStore extends BaseStore {
   constructor() {
      super()

      this.subscribe(this._subscribe.bind(this))
      this._sorting = ['datetime', 'desc']
      this._results = []
      this._incoming = []
      this._columns = [
         // meta
         'key',
         'datetime',
         'received',
         'network',
         'device',

         // event header
         'proto/tm.uid',
         'proto/tm.type',
         'proto/tm.sid',
         'proto/tm.rssi',
         'proto/tm.packet_number',
         'proto/tm.network_lvl',
         'proto/tm.latency',
         'proto/tm.hops',
         'proto/tm.detail',

         // event/serial
         'proto/tm.data',
         'proto/tm.block',

         // zacima
         'proto/tm.analog_io_0',
         'proto/tm.analog_io_1',
         'proto/tm.msg_data'
      ]

      this._locked = false
   }

   static augment(msg) {
      // augment with device/network info
      let parts = msg.key.split(/-/)

      // old style key's
      if (4 < parts.length) {
         let [net, dev] = new Buffer(_.last(parts), 'base64').toString().split('/')

         msg.$key = msg.key
         msg.key = parts.slice(0, 3).join('-')
         msg.network = NetworkStore.network(net)
         msg.device = DeviceStore.device(net, dev)
      }

      return msg
   }

   augment(msg) {
      return MessageStore.augment(msg)
   }

   _collectColumns(msg, allowEmit) {
      const collectPaths = ([path, acc], v, k) => {
         const realpath = !k ? path : path.concat([k])

         if (_.isObject(v) && !_.isArray(v)) {
            _.each(v, (v2, k2) => collectPaths([realpath, acc], v2, k2))

            return [path, acc]
         } else {
            if (-1 === acc.indexOf(realpath)) {
               acc.push(realpath.slice(1).join('.'))
            }

            return [path, acc]
         }
      }

      let cols = collectPaths([[], []], msg, '.')[1],
         newCols = _.without.apply(this, [cols].concat(this._columns))

      if (0 < newCols.length) {
         this._columns = this._columns.concat(newCols)
         if (true === allowEmit) {
            this.emitChange()
         }

         return true
      } else {
         return false
      }
   }

   _subscribe(action) {
      switch (action.actionType) {
         case Actions.read:
         case Actions.write:
            let msg = MessageStore.augment(action.message),
               idx = _.findIndex(this._results, {key: msg.key})

            if (-1 === idx) {
               this._results.push(msg)
               this.emitChange()
            } else if (!_.eq(this._results[idx], msg)) {
               this._results[idx] = msg
               this.emitChange()
            }

            break

         case Actions.fetch:
            this._results = _.map(action.messages, MessageStore.augment)
            _.each(this._results, this._collectColumns, this)
            this.emitChange()
            break

         case Actions.consume:
            this._incoming.push(MessageStore.augment(action.message))

            if (!this._locked) {
               this._locked = true
               _.each(this._incoming, this._collectColumns, this)

               setTimeout(() => {
                  this._results = this._results.concat(this._incoming)
                  this._incoming = []

                  try {
                     this.sort(this._sorting[0], this._sorting[1], false)
                  } catch (_e) {
                     // void
                  }

                  this._locked = false
                  this.emitChange()
               }, 50)
            }

            break

         case Actions.clear:
            this._results = []
            this.emitChange()
            break

         default:
            break
      }
   }

   get columns() {
      return this._columns
   }

   matches(query) {
      return _.filter(this._results, _.isFunction(query) ? query : _.matches(query))
   }

   get messages() {
      return this._results
   }

   get length() {
      return this._results.length
   }

   sort(col, order, emit) {
      this._sorting = [col, order]
      this._results = _.sortByOrder(this._results, [col], [order.toLowerCase()])

      if (false !== emit) {
         this.emitChange()
      }
   }

   at(index) {
      return this._results[index]
   }

   clear() {
      this._results = []
      this.emitChange()
   }
}

export default new MessageStore()



// WEBPACK FOOTER //
// lib/api/message/Store.js